import { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

const get = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lab-lang") || "en");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    localStorage.setItem("lab-lang", l);
    setLangState(l);
  }, []);

  const t = useCallback((path) => get(translations[lang], path) ?? get(translations.en, path) ?? path, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);

export const fill = (str, vars) => str.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");

export const Hl = ({ text }) =>
  text.split(/(\*[^*]+\*|~[^~]+~)/g).map((p, i) => {
    const key = `${i}-${p}`;
    if (p.startsWith("*")) return <span key={key} className="text-brand">{p.slice(1, -1)}</span>;
    if (p.startsWith("~")) return <span key={key} className="text-honey">{p.slice(1, -1)}</span>;
    return p;
  });

export const hlLines = (lines) => lines.map((l) => <Hl key={l} text={l} />);
